<template>
  <div class="d-flex align-items-center">
    <div class="mr-1">
      <span>{{ params.displayName }}</span>
      <span
        v-if="params.showThStar"
        class="text-danger"
        title="Zum Zeitpunkt der Buchung"
        v-b-tooltip.hover
        style="align-self: start; position: absolute"
      >
        <Asterisk :size="14" />
      </span>
    </div>
    <b-button
      class="btn-xs btn p-1 mr-1 justify-content-center align-item-center d-flex"
      v-b-tooltip.hover
      :title="hoverText"
    >
      <Info :size="14" />
    </b-button>
  </div>
</template>

<script>
import { Asterisk, Info } from 'lucide-vue';

export default {
  name: 'CustomInfoIconHeader',
  components: { Asterisk, Info },
  data() {
    return {
      params: null,
    };
  },
  computed: {
    // Muss per headerComponentParams gesetzt werden
    hoverText() {
      return this.params?.hoverText || '';
    },
  },
  beforeMount() {
    this.params = this.params || {};
  },
};
</script>
